import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { TranscriptFeed } from "./TranscriptFeed";
import { Trash2, Copy, Check } from "lucide-react";
import { useState } from "react";
import { copyToClipboard } from "../lib/clipboard";
import { toast } from "sonner";

export function HistoryDrawer({ open, onClose, transcript, interim, listening, onClear }) {
  const [copiedAll, setCopiedAll] = useState(false);

  const handleCopyAll = async () => {
    const full = transcript
      .map((m) => `${m.role === "user" ? "Opérateur" : "Sara"} : ${m.text || ""}`)
      .join("\n\n");
    const ok = await copyToClipboard(full);
    if (ok) {
      setCopiedAll(true);
      toast.success("Rapport complet copié !");
      setTimeout(() => setCopiedAll(false), 1800);
    } else {
      toast.error("Copie impossible sur cet appareil.");
    }
  };

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent
        data-testid="history-drawer"
        side="right"
        className="w-full sm:max-w-md bg-[var(--panel-solid)] border-l border-[var(--border-hud)] text-white p-0 flex flex-col"
      >
        <SheetHeader className="px-5 pt-5 pb-3">
          <SheetTitle className="font-display tracking-[0.15em] accent-text text-glow">HISTORIQUE</SheetTitle>
          <SheetDescription className="font-mono-hud text-[10px] tracking-[0.2em] text-[#8b949e]">
            L'intégralité de votre conversation avec Sara.
          </SheetDescription>
        </SheetHeader>
        <div className="flex-1 min-h-0 px-4 pb-4">
          <TranscriptFeed transcript={transcript} interim={interim} listening={listening} />
        </div>
        <div className="px-5 py-3 border-t border-[var(--border-hud)] flex flex-col gap-2">
          <button
            data-testid="history-copy-all-button"
            onClick={handleCopyAll}
            disabled={!transcript.length}
            className="w-full flex items-center justify-center gap-2 py-2.5 clip-corner border border-[var(--border-hud)] font-mono-hud text-[11px] tracking-[0.15em] uppercase text-[#8b949e] hover:text-[var(--accent)] hover:border-[var(--accent)] transition-colors disabled:opacity-40"
          >
            {copiedAll ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
            {copiedAll ? "Copié !" : "Tout copier"}
          </button>
          <button
            data-testid="history-clear-button"
            onClick={onClear}
            disabled={!transcript.length}
            className="w-full flex items-center justify-center gap-2 py-2.5 clip-corner border border-[var(--border-hud)] font-mono-hud text-[11px] tracking-[0.15em] uppercase text-[#8b949e] hover:text-[#ff6b6b] hover:border-[#ff6b6b] transition-colors disabled:opacity-40"
          >
            <Trash2 className="h-3.5 w-3.5" />
            Effacer la conversation
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
